/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4"

export const publicProfileSchema = z.object({
  id: z.string().min(1),
  username: z.string().min(1),
  email: z.email().optional(),
  phoneNumber: z.string().optional(),
})
